import React from "react";
import { UI_Modal_OTP } from "../../UiComponents/index";
import './Register.css';

function VerifyOTPModal(props) {
  const {
    isSignUpSuccess,
    setIsSignUpSuccess,
    otp,
    setOpt,
    handleSubmitOtp,
    inValidOtp,
    setInValidOtp,
    handleResendOtp,
  } = props;

  // Ensure OTP is always an array of 6 characters
  const otpArray = otp
    ? otp.split("").concat(Array(6 - otp.length).fill(""))
    : Array(6).fill("");

  // Handle OTP change
  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/, ""); // Allow only numbers

    const newOtp = [...otpArray]; // Clone OTP array
    newOtp[index] = value; // Update digit

    setOpt(newOtp.join("")); // Update state

    // Move focus to the next field if a digit is entered
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  // Handle backspace
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otpArray];
      newOtp[index] = ""; // Clear current input
      setOpt(newOtp.join("")); // Update state

      // Move focus to the previous field if current field is empty
      if (index > 0) {
        document.getElementById(`otp-${index - 1}`).focus();
      }
    }
  };

  return (
    <UI_Modal_OTP
      isOpen={isSignUpSuccess}
      closeModal={() => {
        setIsSignUpSuccess(false);
        localStorage.clear();
      }}
      title={
        <>
          Enter verification <br /> code from email
        </>
      }
    >
      <div className="w-full h-full flex flex-col justify-evenly">

        {/* Sub-Title */}
        <div className="SubTitle">
          <h1 className="sub-txt">Please enter the code we emailed you at your email.</h1>
        </div>

        {/* OTP Input Fields */}
        <div className="otp_container flex gap-2 py-[2.3rem]">
          {otpArray.map((digit, index) => (
            <input
              key={index}
              id={`otp-${index}`}
              className="otp_input text-center"
              type="tel"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              placeholder=""
              autoComplete="one-time-code"
              inputMode="numeric"
              pattern="[0-9]*"
            />
          ))}
        </div>

        {/* Invalid OTP Message */}
        {inValidOtp && <p className="text-red-500 mt-2">{inValidOtp}</p>}

        {/* Buttons */}
        <div className="w-full otp_btn_container">
          <button
            className="rounded-[10px] text-white bg-[#5e51d1] py-[10px] xl:text-base manrope-600 w-full"
            onClick={handleSubmitOtp}
          >
            Continue
          </button>
          <button
            className="text-white text-sm w-full text-center py-3 manrope-600"
            onClick={handleResendOtp}
          >
            Resend Code
          </button>
        </div>
      </div>
    </UI_Modal_OTP>
  );
}

export default VerifyOTPModal;


{ /* <input className="otp_input w-[25%] p-1 user_input" type="number" value={otp} onChange={(e) => setOpt(e.target.value)}/> */ }
